function maintenanceModule(FilterApi) {
    __ = null;

    this.render = function () {
        __ = this;
        if (!$("#maintenance-video-list").length) {
            /**
             * Overview page
             */
            var filter_route = $("#aftercare-video-list").attr("data-route");
            __.filterListener(filter_route);
            return;
        }

        if (window.location.hash) {
            __.scrollToActiveVideo(window.location.hash, true);
        }

        $("[data-mm-set-hash]").on("click", function () {
            window.location.hash = $(this).attr("data-mm-set-hash");
        });
    };

    this.filterListener = function (filter_route) {
        FilterApi.setRoute(filter_route);
        FilterApi.changeListener(".js-maintenance-filter-listener");
    };

    this.scrollToActiveVideo = function (hash, autostart = false) {
        var $course_wrapper = $(hash).parents(".course-category");
        var toggle_targer = $course_wrapper.attr("id");
        $('[data-target="#' + toggle_targer + '"]').removeClass("collapsed");
        $("#" + toggle_targer).addClass("show");
        $(hash).parents(".course-item-wrapper").addClass("bg-soft-success");

        if (!toggle_targer) {
            toggle_targer = hash.substring(1);
        }

        if ($("#" + toggle_targer)) {
            $("html, body").animate(
                {
                    scrollTop: $("#" + toggle_targer).offset().top - 200,
                },
                400
            );

            setTimeout(function () {
                var myAElement = document.getElementById(hash.substring(1) + '_button');
                dimbox.open(myAElement);
            }, 500);
        }
    };
}

module.exports = maintenanceModule;
